import React from "react";
const Contact = () => {
    return (
        <div className="screen">
            <strong>EDENLUX CONTACT</strong>
            <p>
            <b>Email:</b> cs@edenlx.com<br/><br/>
            <b>Tel:</b> 1661-8171<br/>
            월 ~ 금 AM 10:00 - PM 5:00<br/>
            (점심시간 PM 12:00 - PM 1:00)<br/>
            </p>
            <br/><br/>
            <strong>COMPANY INFO</strong> 
            <p>
            상호/대표자명 : 주식회사 에덴룩스/박성용 전화 : 1661-8171 사업자 등록번호 안내 : [174-81-00450] 통신판매업 신고 : 제 2016-창원성산-0063 호<br/>
            개인정보관리책임자 : 주식회사 에덴룩스이메일 : cs@edenlx.com 주소 : 경상남도 창원시 성산구 전기의길 12, 신재생에너지연구동 202호<br/>
            입금계좌 : IBK 기업은행 666-037162-04-031 Contact cs@edenlx.com for more information.Copyright © 2022 (주)에덴룩스. All rights reserved. <br/><br/>

            ※ 무단 복제나 도용은 저작권법(97조 5항)에 의해 금지되어 있습니다. 제작물의 저작권은 당사에 있으며 위반시 처벌됩니다.<br/>
            </p> 


        </div>
    )
}
export default Contact